// CUSTOM REPORT DATA SOURCES
export const DATA_SOURCES = [
    {
        id: 'items', name: 'Items', description: 'Devices, parts, and bundles',
        columns: [
            { name: 'name', type: 'string', description: 'Item name', groupable: false, aggregatable: false },
            { name: 'device_type', type: 'string', description: 'Device type name', groupable: true, aggregatable: false },
            { name: 'ip_address', type: 'string', description: 'IP address', groupable: false, aggregatable: false },
            { name: 'mac_address', type: 'string', description: 'MAC address', groupable: false, aggregatable: false },
            { name: 'dns_name', type: 'string', description: 'DNS name', groupable: false, aggregatable: false },
            { name: 'port_id', type: 'string', description: 'Port ID', groupable: false, aggregatable: false },
            { name: 'region', type: 'string', description: 'Region name', groupable: true, aggregatable: false },
            { name: 'building', type: 'string', description: 'Building name', groupable: true, aggregatable: false },
            { name: 'area', type: 'string', description: 'Area name', groupable: true, aggregatable: false },
            { name: 'room', type: 'string', description: 'Room name', groupable: true, aggregatable: false },
            { name: 'deployment_status', type: 'string', description: 'Deployment status name', groupable: true, aggregatable: false },
            { name: 'cost', type: 'number', description: 'Model cost', groupable: false, aggregatable: true },
            { name: 'updated_at', type: 'datetime', description: 'Last updated timestamp', groupable: false, aggregatable: false },
            { name: 'bundle', type: 'string', description: 'Bundle name', groupable: true, aggregatable: false }
        ]
    },
    {
        id: 'locales', name: 'Locales', description: 'Regions, buildings, areas, and rooms',
        columns: [
            { name: 'name', type: 'string', description: 'Locale name', groupable: false, aggregatable: false },
            { name: 'locale_type', type: 'string', description: 'Type (region/building/area/room)', groupable: true, aggregatable: false },
            { name: 'parent', type: 'string', description: 'Parent locale name', groupable: true, aggregatable: false }
        ]
    },
    {
        id: 'device_types', name: 'Device Types', description: 'Device type definitions',
        columns: [
            { name: 'name', type: 'string', description: 'Device type name', groupable: true, aggregatable: false },
            { name: 'device_type_class', type: 'string', description: 'Class (device, part, bundle)', groupable: true, aggregatable: false },
            { name: 'printer', type: 'string', description: 'Is printer', groupable: true, aggregatable: false },
            { name: 'cost', type: 'number', description: 'Cost', groupable: false, aggregatable: true }
        ]
    },
    {
        id: 'deployment_statuses', name: 'Deployment Statuses', description: 'Deployment status definitions',
        columns: [
            { name: 'name', type: 'string', description: 'Status name', groupable: true, aggregatable: false },
            { name: 'status_color', type: 'string', description: 'Color code', groupable: true, aggregatable: false }
        ]
    },
    {
        id: 'testing_task_compliance', name: 'Testing Task Compliance', description: 'Testing task compliance report',
        columns: []
    }
]

// HTML ELEMENT CONSTANTS
export const GRAPH_CANVAS_ID = "graph-holder";
export const TABLE_ID = "table-holder";
export const CHART_TITLE_ID = "chart-title";

// REPORT TITLES
export const CHANGES_IN_LAST_TWO_WEEKS_REPORT_TITLE = "Changes in last 2 weeks";
export const COST_BY_STATUS_REPORT_TITLE = "Cost by Status";
export const COST_SUMMARY_REPORT_TITLE = "Cost Summary";
export const DEVICES_BY_STATUS_REPORT_TITLE = "Devices by Status";
export const TOTAL_DEVICES_REPORT_TITLE = "Total Devices";

// DATA FIELDS
export const DEVICE_TYPE_FIELD = 'device.device_type.name';
export const MANUFACTURER_FIELD = 'device.manufacturer.name';
export const MODEL_FIELD = 'device.model.name';
export const AREA_DATA_FIELD = 'locale.area.name';
export const BUILDING_DATA_FIELD = 'locale.building.name';
export const COST_DATA_FIELD = 'device.model.cost';
export const COUNT_FIELD = 'count'
export const DEPLOYMENT_STATUS_FIELD = "deployment_status";
export const IP_ADDRESS_FIELD = 'ip_address'
export const NAME_DATA_FIELD = 'name';
export const ROOM_DATA_FIELD = "locale.room.name";
export const TOTAL_COST_FIELD = 'total_cost';
export const UPDATED_AT_DATA_FIELD = "updated_at";
export const DNS_NAME_FIELD = 'dns_name'

// MAGIC NUMBERS
export const DEFAULT_PAGE_SIZE = 1000;
export const BAR_CHART = 'bar'
export const LINE_CHART = 'line'
export const PIE_CHART = 'pie'

export const NULL_DEPLOYMENT_STATUS_ID = null;
export const NULL_DEVICE_TYPE_ID = null;
export const NULL_UPDATED_AT_DATE = null;